module.exports = __webpack_public_path__ + "static/media/5_CAM.fbb862ee.png";